import React, {Component,} from 'react'

import { CCIcon} from './../../cc-imports'

import PropTypes from 'prop-types'
// import './cc-coins.css'
import './../../styles/css/components/CCCoins/cc-coins.css'

class CCCoins extends Component {

    static propTypes = {
        height: PropTypes.number,
        onCoinsIconPress: PropTypes.func,
        onCoinsPress: PropTypes.func,
        onPlusPress: PropTypes.func,

        coins: PropTypes.number,
        loggedIn: PropTypes.bool
    }

    static defaultProps = {
        height: 40,
        onCoinsIconPress: () => {
        },
        onCoinsPress: () => {
        },
        onPlusPress: () => {
        },

        coins: 1000,
        loggedIn: false
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        //const resStyles = styles.default;

        return (
            <div className={'flex-container parent'} style={{ ...this.props.style}}>
                <div className={'flex-container coins_base parent-image-background'}>
                    <CCIcon className={'btn cc-coin-icon-s coins-icon'} analytics={{event: 'CoinsIconClicked', params: {loggedIn: this.props.loggedIn}}}
                            type={'coins'}
                            onPress={this.props.onCoinsIconPress}></CCIcon>
                    <div className={'flex-container coins_text_base coins-image-background'}>
                        <h1 className={'btn coins-header-text coins-header'}>{this.props.coins}</h1>
                    </div>
                    <CCIcon className={'btn cc-icon-plus-xxs'} analytics={{event: 'AddCoinsClicked', params: {loggedIn: this.props.loggedIn}}}
                            type={'coinsPlus'}
                            onPress={this.props.onPlusPress}></CCIcon>
                </div>
            </div>
        )
    }
}

export default CCCoins



// WEBPACK FOOTER //
// ./src/app/components/CCCoins/CCCoins.js